import React from 'react'
import {Scrollchor} from 'react-scrollchor'

const GenerateTOC = (elems) => {
  const headings = elems.length && elems.filter(elem => {
    return elem.props.mdxType === "h2"
  });

  const toc = {}

  for (const heading of headings) {
    let text = heading.props.children
    let string = heading.props.id
    toc[text] = string
  }

  const tocTree = Object.entries(toc).map(([heading, url]) => {
    return (
      <li className="fs-2 c-neutral-400 hover:c-secondary-500 mb-2 antialiased wc-transform hover:translate" key={url}>
        <Scrollchor to={`#${url}`}
          animate={{offset: -100, duration: 280}}
          className="c-inherit td-none" >
          {heading}
        </Scrollchor>
      </li>
    )
  })

  return  tocTree
}

export default GenerateTOC